export const CURRENT_PAPER_UPDATE = 'CURRENT_PAPER_UPDATE'
export const CUREENT_PAPER_ERROR = 'CUREENT_PAPER_ERROR'

